import { BrowserModule } from '@angular/platform-browser';
// 2019-11-12, removed: import { ErrorHandler, Injectable, Injector, NgModule } from '@angular/core';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule/*, Platform*/ } from 'ionic-angular';
//import { DatePipe } from "@angular/common";
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { InAppBrowser } from '@ionic-native/in-app-browser';
//import { BackgroundMode } from "@ionic-native/background-mode";
import { BackgroundFetch } from "@ionic-native/background-fetch";
import { MusicControls } from '@ionic-native/music-controls';
import { Keychain } from "@ionic-native/keychain";
import { KeychainTouchId } from "@ionic-native/keychain-touch-id";
import { UniqueDeviceID } from '@ionic-native/unique-device-id';
import { Crashlytics } from "@ionic-native/fabric";

import { MyApp } from './app.component';

import { GlobalvarsProvider } from '../providers/globalvars/globalvars';
import { ApiProvider } from '../providers/api/api';
import { SyncProvider } from '../providers/sync/sync';
import { AudioProvider } from '../providers/audio/audio';
import { LoggerProvider } from '../providers/logger/logger';
import { CronProvider } from '../providers/cron/cron';

import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { IonicStorageModule } from '@ionic/storage';
import { File } from '@ionic-native/file';
import { FileTransfer } from "@ionic-native/file-transfer";
import { FileOpener } from "@ionic-native/file-opener";
import { Media } from '@ionic-native/media';
import { Httpd } from '@ionic-native/httpd';

//import { LogProvider, LogProviderConfig } from 'ionic-log-file-appender';

// 2019-11-12, removed: import { Pro } from "@ionic/pro";


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

/*export function provideLogger(file: File, platform: Platform, datePipe: DatePipe) {
  // Provider for persistent file logging services
  return new LogProvider(file, platform, datePipe, new LogProviderConfig({
    //your config here
  }));
}/**/

/* 2019-11-12, removed:
   https://ionic.zendesk.com/hc/en-us/articles/360034971514-2019-10-01-Announcement-Removal-of-Monitoring-from-Ionic-Appflow-

const IonicPro = Pro.init('c424779a', {
  appVersion: "1.6.4"
});

@Injectable()
export class MyErrorHandler implements ErrorHandler {
  ionicErrorHandler: IonicErrorHandler;

  constructor(injector: Injector) {
    try {
      this.ionicErrorHandler = injector.get(IonicErrorHandler);
    } catch(e) {
      // Unable to get the IonicErrorHandler provider, ensure
      // IonicErrorHandler has been added to the providers list below
    }
  }

  handleError(err: any): void {
    IonicPro.monitoring.handleNewError(err);
    // Remove this if you want to disable Ionic's auto exception handling
    // in development mode.
    this.ionicErrorHandler && this.ionicErrorHandler.handleError(err);

    // 2019-03-23
    console.error(err);
  }
}
*/

@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp),
    IonicStorageModule.forRoot(),
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [
    StatusBar,
    SplashScreen,
    InAppBrowser,
    GlobalvarsProvider,
    ApiProvider,
    SyncProvider,
    AudioProvider,
    Httpd,
    File,
    FileOpener,
    FileTransfer,
    Media,
    MusicControls,
    //BackgroundMode,
    BackgroundFetch,
    Keychain,
    KeychainTouchId,
    UniqueDeviceID,
    Crashlytics,
    //SQLite,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    // 2019-11-12, removed: {provide: ErrorHandler, useClass: MyErrorHandler},
    LoggerProvider,
    CronProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts